/*** IMPORTS FROM imports-loader ***/
var define = false;

/* global gtag */

import $ from 'jquery'

export function setupA9S() {
  $(document).on('click', '[data-ga-on]', (ev) => {
    const $target = $(ev.currentTarget)
    const category = $target.data('ga-event-category')
    const action = $target.data('ga-event-action')
    const label = $target.data('ga-event-label')

    if (typeof gtag !== 'undefined') {
      const params = {}
      if (category) {
        params.EventCategory = category
      }
      if (action) {
        params.EventAction = action
      }
      if (label) {
        params.EventLabel = label
      }
      gtag('event', 'ui_interaction', params)
    }
  })
}

